import { type WidgetSettingsDefinition } from "@repo/api";
import { ListViewItem, Switch, startFilledIcon } from "@repo/skapa";
import { Text } from "@repo/skapa";
import { FlexDiv, translateKey } from "@repo/ui";

export const BooleanSettingsControl = ({
  settingDefinition,
  setting,
  setSetting,
}: {
  settingDefinition: WidgetSettingsDefinition;
  setting: Record<string, any>;
  setSetting: (newSetting: Record<string, object>) => void;
}) => {
  const value = setting[settingDefinition.id] ?? false;
  return (
    <ListViewItem
      leadingIcon={startFilledIcon}
      description={
        <FlexDiv justifyContent="space-between">
          <Text textStyle="Heading.XS">
            {translateKey(settingDefinition.title)}
          </Text>
          <Switch
            id={`id-${settingDefinition.id}`}
            subtle
            onChange={() => {
              setSetting({ ...setting, [settingDefinition.id]: !value });
            }}
            defaultChecked={value}
            value={value}
          />
        </FlexDiv>
      }
    />
  );
};
